import { FileUp, LoaderCircle } from "lucide-react";
import { type ChangeEvent, useRef, useState } from "react";

import { request } from "../api";
import type { Book } from "../types";
import { errorMessage } from "../utils";

export function UploadBook({
  onUploaded,
  compact = false
}: {
  onUploaded: (book: Book) => void;
  compact?: boolean;
}) {
  const input = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function upload(event: ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError("");
    const body = new FormData();
    body.append("file", file);
    try {
      onUploaded(await request<Book>("/api/books", { method: "POST", body }));
    } catch (reason) {
      setError(errorMessage(reason));
    } finally {
      setBusy(false);
      event.target.value = "";
    }
  }

  return (
    <div className={`upload-control ${compact ? "upload-control--compact" : ""}`}>
      <input ref={input} type="file" accept=".epub,application/epub+zip" onChange={upload} hidden />
      <button className="primary-button" onClick={() => input.current?.click()} disabled={busy}>
        {busy ? <LoaderCircle className="spin" size={17} /> : <FileUp size={17} />}
        {busy ? "正在导入…" : "导入 EPUB"}
      </button>
      {error && <span className="upload-control__error">{error}</span>}
    </div>
  );
}
